import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { ResultCenter, ResultCenterRequest } from '../models/resultCenter';

/**
 * <p>
 * API endpoints that cover all project related CRUD calls
 */
export const resultCenterApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    searchResultCenter: builder.query<PaginationResponse<ResultCenter>, ResultCenterRequest>({
      query: (params: ResultCenterRequest) => ({
        url: encodeURI(
          `/approvers/project/search?bringClose=${params.bringClose}&searchTerm=${params.searchTerm}&page=${params.page}&size=${params.size}&sortKey=${params.sortKey}&sortDirection=ASC`,
        ),
      }),
      providesTags: ['ResultCenter'],
    }),
  }),
});

export const { useSearchResultCenterQuery } = resultCenterApi;
